import React from 'react';
import location_Img from '../../images/icon/location.png';

function TrackingLogs({ data  }) {

    const shipment = data?.data?.[0];
    if (!shipment) {
        return null;
    }
    const statusStyles = {
    "Not Picked": { bg: "#FF660015", color: "#FF6600" },
    "Booked": { bg: "#FF660015", color: "#FF6600" },
    "RVP BOOKED": { bg: "#FF660015", color: "#FF6600" },
    "Manifested": { bg: "#16478310", color: "#164783" },
    "Picked": { bg: "#6155F510", color: "#6155F5" },
    "RVP PICKED": { bg: "#6155F510", color: "#6155F5" },
    "Pickup Pending": { bg: "#6155F510", color: "#6155F5" },
    "In-Transit": { bg: "#FFDB4310", color: "#DFB400" },
    "In Transit": { bg: "#FFDB4310", color: "#DFB400" },
    "RTO-Dispatched": { bg: "#FFDB4310", color: "#DFB400" },
    "Out for Delivery": { bg: "#0088FF10", color: "#0088FF" },
    "Out For Pickup": { bg: "#0088FF10", color: "#0088FF" },
    "RVP OFD": { bg: "#0088FF10", color: "#0088FF" },
    "Dispatched": { bg: "#66BB1820", color: "#66BB18" },
    "NDR": { bg: "#0088FF10", color: "#0088FF" },
    "Delivered": { bg: "#1FC16B10", color: "#1FC16B" },
    "Returning to Origin": { bg: "#D0041610", color: "#D00416" },
    "Returned to Source": { bg: "#D0041610", color: "#D00416" },
    "Cancelled": { bg: "#D0041610", color: "#D00416" },
    "RTS": { bg: "#D0041610", color: "#D00416" },
    "RTO-IT": { bg: "#FFDB4310", color: "#DFB400" },
    "RTO-Pending": { bg: "#FFDB4310", color: "#DFB400" },
    "RTO": { bg: "#D0041610", color: "#D00416" },
    "DTO REJECTED": { bg: "#D0041610", color: "#D00416" },
    "LOST": { bg: "#D0041610", color: "#D00416" }
        };

        const currentStatus = shipment?.current_status;

        const style = statusStyles[currentStatus] || {
            bg: "#eee",
            color: "#333"
        };
        const logs = shipment?.all_logs || [];

        const latestLog = logs[logs.length - 1];

        const remainingLogs = logs
            .slice(0, logs.length - 1)
            .reverse();
        const formatDateTime = (dateTime) => {

            if (!dateTime) return "";

            const date = new Date(dateTime);

            return date.toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });

        };
    return (
        <div>
            <div className="section-02">
                <div className='container-fluid'>
                    <div className="col-md-11 mx-auto">

                        <div className='row'>

                            {/* LEFT CARD */}
                            <div className="col-xl-4 mb-3">

                                <div className="tracking-card information mb-4">
                                    {/* <div className='d-flex align-items-center justify-content-between border-bottom pb-3 mb-3'>
                                        <p className='mb-0'>Order Id</p>
                                        <h6 className='mb-0'>{shipment?.shipment_id}</h6>
                                    </div> */}
                                    
                                    <div>
                                        {shipment?.estimated_delivery_date &&
                                        shipment?.current_status !== "Delivered" &&
                                        shipment?.current_status !== "RTS" && (
                                            <>
                                                <p>
                                                    Estimated Delivery Date
                                                </p>

                                                <h3>
                                                    {shipment.estimated_delivery_date}
                                                </h3>
                                            </>
                                        )}

                                        <div
                                            className="shipment-status"
                                            style={{
                                                backgroundColor: style.bg,
                                                color: style.color
                                            }}
                                        >
                                            <span
                                                style={{
                                                    backgroundColor: style.color
                                                }}
                                            ></span>

                                            {currentStatus}
                                        </div>

                                    </div>

                                    <div className='location-box mt-4'>

                                        <img
                                            src={location_Img}
                                            height={20}
                                            alt="location"
                                        />

                                        <h6 className='mb-0'>
                                            <span className='text-gray me-1'>
                                                Delivery Destination:
                                            </span>

                                            {shipment?.destination}
                                        </h6>

                                    </div>

                                </div>

                            </div>

                            {/* RIGHT CARD */}
                            <div className='col-xl-8 mb-3'>

                                <div className='tracking-card px-0 pb-0'>

                                    {/* Header */}
                                    <div className='border-bottom pb-3 mb-3'>

                                        <div className="d-sm-flex align-items-center justify-content-between px-3">
                                            <div>
                                                <p className='mb-2'>Tracking ID</p>

                                                <h6 className='mb-0'>
                                                    {shipment?.awb_number}
                                                </h6>

                                            </div>

                                            <h6> {shipment?.from_destination} <i class="fas fa-arrows-h mx-2"></i> {shipment?.to_destination} </h6>

                                            <img src={shipment?.partner_display_logo} height="45" alt={shipment?.partner_display_name} />

                                        </div>

                                    </div>

                                    {/* Tracking Logs */}
                                    <div className='tracking-body'>

                                        <div className={`table-responsive ${
                                                shipment?.all_logs?.length > 6 ? 'active' : ''
                                            }`}>

                                            <table>

                                                <thead>

                                                    {latestLog && (
                                                        <tr>

                                                            <th width="60">
                                                                <div className="cricle-line">
                                                                    <i className="far fa-circle"></i>
                                                                </div>
                                                            </th>

                                                            <th>
                                                                <h3>{latestLog.status_title}</h3>

                                                                <p>
                                                                    {formatDateTime(latestLog.updated_on)}

                                                                    {latestLog.status_location && (
                                                                        <span>
                                                                            {' '} {latestLog.status_location}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            </th>

                                                            <th>
                                                                <p>{latestLog.status_description}</p>
                                                            </th>

                                                        </tr>
                                                    )}

                                                </thead>

                                                <tbody>

                                                    {remainingLogs.map((log, index) => (

                                                        <tr key={index}>

                                                            <td width="60">
                                                                <div className="cricle-line">
                                                                    <i className="far fa-circle"></i>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <h3>{log.status_title}</h3>

                                                                <p>
                                                                    {formatDateTime(log.updated_on)}

                                                                    {log.status_location && (
                                                                        <span>
                                                                            {' '} {log.status_location}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            </td>

                                                            <td>
                                                                <p>{log.status_description}</p>
                                                            </td>

                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </table>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrackingLogs;